import Login from '@/containers/Login';
import { getToken, getLanguage } from '@/utils/cookies';

Login.getInitialProps = ctx => ({ token: getToken(ctx), initialLanguage: getLanguage(ctx) });

export default Login;
